import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Grid, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';

const gridStyles = xcss({
	height: '920px',
});

const leftSidebarStyles = xcss({
	height: '100%',
	paddingBottom: 'space.0',
});

const mainContentStyles = xcss({
	height: '100%',
});

const chatSectionStyles = xcss({
	height: '100%',
	width: '100%',
	paddingTop: 'space.100',
	paddingBottom: 'space.0',
	paddingInline: 'space.200',
	overflow: 'auto',
	maxWidth: 'min(800px, 50vw)',
	marginInline: 'auto',
});

const conversationListStyle = xcss({
	padding: 'space.300',
});

export const ChatSimulatorLoadingState = () => (
	<Grid xcss={gridStyles} rowGap="space.200" columnGap="space.0" templateColumns="360px 1fr">
		<Stack alignBlock="start" xcss={leftSidebarStyles} space="space.200">
			<Box padding="space.300">
				<Skeleton isShimmering width="100%" height="32px" borderRadius={3} />
			</Box>
			<Stack space="space.100" xcss={conversationListStyle}>
				<Skeleton isShimmering width="100%" height="36px" borderRadius={3} />
				<Skeleton isShimmering width="100%" height="36px" borderRadius={3} />
				<Skeleton isShimmering width="100%" height="36px" borderRadius={3} />
				<Skeleton isShimmering width="100%" height="36px" borderRadius={3} />
			</Stack>
		</Stack>
		<Stack xcss={mainContentStyles} spread="space-between">
			<Box padding="space.300">
				<Skeleton isShimmering width="50%" height="32px" borderRadius={0} />
			</Box>
			<Stack xcss={chatSectionStyles} alignBlock="end" space="space.200">
				<Skeleton isShimmering width="440px" height="120px" borderRadius={2} />
				<Stack space="space.050" alignInline="end">
					<Skeleton isShimmering width="240px" height="32px" borderRadius={8} />
					<Skeleton isShimmering width="320px" height="32px" borderRadius={8} />
					<Skeleton isShimmering width="180px" height="32px" borderRadius={8} />
				</Stack>
				<Stack space="space.100">
					<Skeleton isShimmering width="100%" height="84px" borderRadius={8} />
					<Skeleton isShimmering width="100%" height="40px" borderRadius={0} />
				</Stack>
			</Stack>
		</Stack>
	</Grid>
);
